"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateProfiles = void 0;
const gs = require("@ivanlog/gs");
const com = require("../../com/tmpls");
const StatePaged_1 = require("../abstracts/StatePaged");
const gs_1 = require("@ivanlog/gs");
const StateProfile_1 = require("./StateProfile");
const StateProfileCreateByPhone_1 = require("./StateProfileCreateByPhone");
const AccessTypeEnum_1 = require("../../enums/AccessTypeEnum");
class StateProfiles extends StatePaged_1.StatePaged {
    static SelectUser() {
        return new Promise((resolve) => {
            gs_1.StateGS.Run(StateProfiles, { callbackOnSelect: resolve });
        });
    }
    constructor() {
        super(com.PageList, "Profiles", true);
        this._callbackOnSelect = null;
        this._users = [];
        this._filteredUsers = [];
        this._currentPage = 0;
        this._roleFilter = "client";
        this._roleFilterTouched = false;
        this._lastQuery = "";
        this.page.ctrls.blockSearch.show();
        this.page.ctrls.blockFilters.show();
        this.page.ctrls.blockPagination.hide();
        this.page.ctrls.taSearch.el.placeholder = "Search profiles";
        this.page.ctrls.taSearch.el.setAttribute("validrules", "req");
        this.page.ctrls.btnSearch.onclick = () => this.trySearch();
        this.page.ctrls.btnPrevPage.onclick = () => this._changePage(-1);
        this.page.ctrls.btnNextPage.onclick = () => this._changePage(1);
        this._setupRoleFilterUi();
        const filterEl = this._getFilterElement();
        if (filterEl)
            filterEl.onchange = () => this._handleRoleFilterChange();
        this.page.ctrls.btnNew.onclick = () => gs_1.StateGS.Run(StateProfileCreateByPhone_1.StateProfileCreateByPhone);
        if (!this.app.auth.hasAccess(AccessTypeEnum_1.AccessTypeEnum.UsersControl))
            this.page.ctrls.btnNew.hide();
    }
    start(arg) {
        const _super = Object.create(null, {
            start: { get: () => super.start }
        });
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            let dataLoaded = false;
            if (arg) {
                this._callbackOnSelect = (_a = arg.callbackOnSelect) !== null && _a !== void 0 ? _a : null;
                if (arg.role) {
                    const roleValue = arg.role.trim().toLowerCase();
                    if (this._isRoleValue(roleValue)) {
                        this._roleFilter = roleValue;
                        this._setFilterSelection();
                        this._roleFilterTouched = true;
                    }
                }
                if (arg.search) {
                    const query = arg.search.trim();
                    this.page.ctrls.taSearch.value = query;
                    dataLoaded = yield this._loadUsers(query);
                    this._syncUrl();
                }
                if (this._callbackOnSelect)
                    this.title = "Search and select profile:";
            }
            if (!dataLoaded) {
                yield this._loadUsers("");
                this._syncUrl();
            }
            return _super.start.call(this, arg);
        });
    }
    trySearch() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const rawValue = (_a = this.page.ctrls.taSearch.value) !== null && _a !== void 0 ? _a : "";
            const query = rawValue.trim();
            if (!query)
                return;
            const loaded = yield this._loadUsers(query);
            if (loaded)
                this._syncUrl();
            this.page.ctrls.taSearch.value = query;
        });
    }
    _loadUsers(query) {
        return __awaiter(this, void 0, void 0, function* () {
            const safeQuery = query !== null && query !== void 0 ? query : "";
            const roles = this._buildRoleFilter();
            const users = yield this.lockgui(this.app.api.admin.profiles.searchUsers(safeQuery, roles, 0, StateProfiles.SearchTake));
            if (!Array.isArray(users))
                return false;
            this._lastQuery = safeQuery;
            this._applyUsers(users);
            return true;
        });
    }
    _applyUsers(users) {
        this._users = [...users].sort((a, b) => this._getCreatedTimestamp(b) - this._getCreatedTimestamp(a));
        this._currentPage = 0;
        this._updateFilteredUsers();
    }
    _renderCurrentPage() {
        const start = this._currentPage * StateProfiles.PageSize;
        const pageItems = this._filteredUsers.slice(start, start + StateProfiles.PageSize);
        this._renderList(pageItems);
        this._updatePager();
    }
    _renderList(users) {
        this.page.ctrls.list.html = "";
        if (users.length === 0) {
            const placeholder = gs.w(gs.html.tag("div", { class: "list-empty" }, "No profiles found"));
            this.page.ctrls.list.append(placeholder);
            return;
        }
        for (const user of users) {
            const item = new com.ListItem();
            item.ctrls.lType.text = "Profile";
            item.ctrls.lId.text = `#${user.id}`;
            const lines = [
                gs.text.clearHtmlToText(`${user.name} ${user.surname}`),
            ];
            for (const auth of user.auths)
                lines.push(`${auth.authType}: ${gs.text.clearHtmlToText(auth.data)}`);
            item.ctrls.pData.html = lines.join("<br>");
            this.page.ctrls.list.append(item);
            if (this._callbackOnSelect)
                item.onclick = () => this._callbackOnSelect(user);
            else
                item.onclick = () => gs_1.StateGS.Run(StateProfile_1.StateProfile, { id: user.id.toString() });
        }
    }
    _updatePager() {
        const totalItems = this._filteredUsers.length;
        if (totalItems === 0) {
            this.page.ctrls.blockPagination.hide();
            return;
        }
        const totalPages = Math.max(1, Math.ceil(totalItems / StateProfiles.PageSize));
        const currentPage = Math.min(this._currentPage + 1, totalPages);
        this.page.ctrls.blockPagination.show();
        this.page.ctrls.lPageInfo.text = `Page ${currentPage} of ${totalPages}`;
        if (this._currentPage === 0)
            this.page.ctrls.btnPrevPage.disable();
        else
            this.page.ctrls.btnPrevPage.enable();
        if (this._currentPage >= totalPages - 1)
            this.page.ctrls.btnNextPage.disable();
        else
            this.page.ctrls.btnNextPage.enable();
    }
    _changePage(offset) {
        if (!offset)
            return;
        const totalPages = Math.max(1, Math.ceil(this._filteredUsers.length / StateProfiles.PageSize));
        const nextPage = this._currentPage + offset;
        if (nextPage < 0 || nextPage >= totalPages)
            return;
        this._currentPage = nextPage;
        this._renderCurrentPage();
    }
    _setupRoleFilterUi() {
        this.page.ctrls.blockFilters.show();
        if (this.page.ctrls.labelFilter)
            this.page.ctrls.labelFilter.text = "User type";
        const select = this._getFilterElement();
        if (!select)
            return;
        select.innerHTML = "";
        select.append(new Option("Clients", "client"));
        select.append(new Option("Drivers", "driver"));
        select.append(new Option("Admins", "admin"));
        this._setFilterSelection();
    }
    _handleRoleFilterChange() {
        var _a;
        const select = this._getFilterElement();
        const value = ((_a = select === null || select === void 0 ? void 0 : select.value) !== null && _a !== void 0 ? _a : "client");
        if (!this._isRoleValue(value)) {
            this._setFilterSelection();
            return;
        }
        this._roleFilterTouched = true;
        if (value === this._roleFilter) {
            this._setFilterSelection();
            this._currentPage = 0;
            this._updateFilteredUsers();
            this._syncUrl();
            return;
        }
        this._roleFilter = value;
        this._currentPage = 0;
        this._updateFilteredUsers();
        this._setFilterSelection();
        this._syncUrl();
    }
    _updateFilteredUsers() {
        const hasQuery = this._lastQuery.length > 0;
        const shouldFilterByRole = this._roleFilter !== "client" || !hasQuery || this._roleFilterTouched;
        this._filteredUsers = shouldFilterByRole
            ? this._users.filter((user) => this._matchesRole(user))
            : [...this._users];
        if (this._filteredUsers.length === 0) {
            this._currentPage = 0;
            this._renderCurrentPage();
            return;
        }
        const totalPages = Math.max(1, Math.ceil(this._filteredUsers.length / StateProfiles.PageSize));
        this._currentPage = Math.min(this._currentPage, totalPages - 1);
        this._renderCurrentPage();
    }
    _syncUrl() {
        if (this._lastQuery)
            this._urlArgs["search"] = this._lastQuery;
        else
            delete this._urlArgs["search"];
        if (this._roleFilter !== "client")
            this._urlArgs["role"] = this._roleFilter;
        else
            delete this._urlArgs["role"];
        this.updateUrl();
    }
    _matchesRole(user) {
        const isDriver = this._isDriver(user);
        const isAdmin = this._isAdmin(user);
        switch (this._roleFilter) {
            case "driver":
                return isDriver;
            case "admin":
                return isAdmin;
            default:
                return !isDriver && !isAdmin;
        }
    }
    _isDriver(user) {
        return this.app.auth.userHasAccess(user, AccessTypeEnum_1.AccessTypeEnum.Driver);
    }
    _isAdmin(user) {
        for (const accessType of StateProfiles.AdminAccessTypes)
            if (this.app.auth.userHasAccess(user, accessType))
                return true;
        return false;
    }
    _buildRoleFilter() {
        switch (this._roleFilter) {
            case "driver":
                return [AccessTypeEnum_1.AccessTypeEnum.Driver];
            case "admin":
                return StateProfiles.AdminAccessTypes;
            default:
                return [];
        }
    }
    _getFilterElement() {
        var _a;
        const element = (_a = this.page.ctrls.selectFilter) === null || _a === void 0 ? void 0 : _a.el;
        if (element instanceof HTMLSelectElement)
            return element;
        return null;
    }
    _setFilterSelection() {
        const select = this._getFilterElement();
        if (select)
            select.value = this._roleFilter;
    }
    _isRoleValue(value) {
        return value === "client" || value === "driver" || value === "admin";
    }
    _getCreatedTimestamp(user) {
        const created = user === null || user === void 0 ? void 0 : user.created;
        if (!created)
            return 0;
        if (created instanceof Date)
            return created.getTime();
        const timestamp = new Date(created).getTime();
        return Number.isNaN(timestamp) ? 0 : timestamp;
    }
}
exports.StateProfiles = StateProfiles;
StateProfiles.StateName = "profiles";
StateProfiles.PageSize = 20;
StateProfiles.SearchTake = 500;
StateProfiles.AdminAccessTypes = [
    AccessTypeEnum_1.AccessTypeEnum.SuperAdmin,
    AccessTypeEnum_1.AccessTypeEnum.UsersControl,
    AccessTypeEnum_1.AccessTypeEnum.Manager,
    AccessTypeEnum_1.AccessTypeEnum.ActiveControl,
    AccessTypeEnum_1.AccessTypeEnum.RateControl,
    AccessTypeEnum_1.AccessTypeEnum.VehicleControl,
    AccessTypeEnum_1.AccessTypeEnum.CompanyControl,
    AccessTypeEnum_1.AccessTypeEnum.DriverControl,
];
//# sourceMappingURL=StateProfiles.js.map